import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.scss";

function Loader({ style }) {
  return (
    <div className="loader" style={style}>
      <FontAwesomeIcon className="icon" icon={["fas", "circle-notch"]} />
    </div>
  );
}

export default Loader;
